import * as React from 'react'
import { ReactElement, useContext, useEffect, useState } from 'react'

import { AppContext } from "../../../Context/AppContext"

import { UserAppPostier } from "./Postier"
import { postier } from "../Postier"
import { Search } from '../../Search'

import "./userapp.scss";

export interface IUser {
    ID: number,
    Username: string
}

export interface IClient {
    clientId: number,
    clientName: string
    code: string
}

export function UserApp(): ReactElement {

    const { token, userId, setErrors } = useContext(AppContext);

    const [fields, setFields] = useState({ userAppId: 0, clientsIds: [] });

    const [userList, setUserList] = useState<IUser[]>([]);    
    const [clientList, setClientList] = useState<IClient[]>([]);
    const [clients, setClients] = useState<string[]>([])
    const [filteredList, setFilteredList] = useState<IClient[]>([])

    useEffect(() => {
        UserAppPostier.getUserList(token, "ConsoleAdminBD", setUserList)
        UserAppPostier.getClientList(token, setClientList, userId, setErrors)
    }, [])

    useEffect(() => {
        postier.getAllClients(token, setClients, fields.userAppId, setErrors)
    }, [fields.userAppId])

    useEffect(() => {
        if (userList.length !== 0) {
            const fieldsCopy = { ...fields };
            fieldsCopy.userAppId = userList[0].ID
            setFields(fieldsCopy)
        }
    }, [userList])

    useEffect(() => {
        setFilteredList(clientList);
    }, [clientList]);

    const validate = () => {
        const userAppBody = {
            clients: fields.clientsIds,
            userapp: fields.userAppId,
            apiId: localStorage.getItem('apiId')
        }
        UserAppPostier.affectUserApp(token, userAppBody, setErrors)
    }

    const handleChange = (field: string, e) => {
        const fieldsCopy = { ...fields };
        fieldsCopy[field] = parseInt(e.target.value);
        setFields(fieldsCopy);
    };

    const handleCheck = (e) => {
        const fieldsCopy = { ...fields }
        if (e.target.checked) {
            fieldsCopy.clientsIds.push(parseInt(e.target.value))
        } else {
            const index = fieldsCopy.clientsIds.indexOf(parseInt(e.target.value))
            fieldsCopy.clientsIds.splice(index, 1)
        }
        setFields(fieldsCopy)
    }

    const handleSelectAll = (e) => {
        const checkedGlobal = e.target.checked;
        const fieldsCopy = { ...fields };

        if (checkedGlobal) {
            filteredList.map((client) => {
                !clients.includes(`${client.code}:${client.clientName}:${localStorage.getItem('apiId')}`) && fieldsCopy.clientsIds.push(client.clientId)
            });
        } else {
            fieldsCopy.clientsIds.length = 0
        }

        setFields(fieldsCopy)
    };

    return (
        <div className="form-client">
            <label>Utilisateurs</label>
            <select onChange={e => handleChange('userAppId', e)}>
                {userList.map((user: IUser, index: number) => {
                    return <option key={index} value={user.ID}>{user.Username}</option>
                })}
            </select>
            <div>

            </div>
            <div className="clients">
                <span>Clients</span>
                <Search needle={clientList} setFilteredList={setFilteredList} searchParam={"code"} style={{width: '90%', border: '1px solid black'}} />
                <span>Tout sélectionner</span>
                <input type="checkbox" onClick={handleSelectAll} id="search-all" />
                {filteredList.map((client: IClient, index: number) => {
                    return !clients.includes(`${client.code}:${client.clientName}:${localStorage.getItem('apiId')}`) && <div key={index}><input type="checkbox" checked={fields.clientsIds.includes(client.clientId)} onChange={handleCheck} value={client.clientId} /> {client.code} : {client.clientName}</div>
                })}
            </div>
            <button onClick={validate} >Enregistrer</button>
        </div>
    )
}
